import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IDesignationList } from '../../../Pages/UserDesignation/IDesignation';

export const DesignationSlicer = createSlice({
  name: 'Designation',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IDesignationList[]>,
  reducers: {
    getDesignation: (state, _) => {
      state.isLoading = true;
    },
    successGetDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetDesignation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDesignation: (state, action) => {
      state.data = {};
    },
  },
});

export const {
  getDesignation,
  failureGetDesignation,
  successGetDesignation,
  clearDesignation,
} = DesignationSlicer.actions;

export default DesignationSlicer.reducer;
